/**
 * magon-brinde-guard.js
 * Normaliza a quantidade de itens com a tag 'brinde' no carrinho para 1.
 *
 * Camada de segurança contra burla via API (/cart/add?quantity=N, /cart/change):
 * a UI já trava o seletor de quantidade, mas alguém pode forçar N>1 pela API.
 * Aqui, sempre que o carrinho renderiza/atualiza, se um item brinde estiver com
 * quantidade > 1, forçamos de volta para 1 e recarregamos para refletir tudo
 * (count, totais, checkout). Não é 100% (quem pula o carrinho e vai direto ao
 * checkout não passa por aqui — isso exigiria Shopify Function), mas cobre os
 * fluxos normais de drawer e página de carrinho.
 *
 * Depende de o tema marcar a linha do brinde no cart-products.liquid:
 *   <tr ... data-key="{{ item.key }}" data-magon-brinde data-magon-qty="{{ item.quantity }}">
 */
(function () {
  'use strict';

  function storageGet(key) {
    try { return sessionStorage.getItem(key); } catch (_) { return null; }
  }

  function storageSet(key, value) {
    try { sessionStorage.setItem(key, value); } catch (_) {}
  }

  function storageRemove(key) {
    try { sessionStorage.removeItem(key); } catch (_) {}
  }

  function fixBrindes() {
    var rows = document.querySelectorAll('[data-magon-brinde]');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var key = row.getAttribute('data-key');
      if (!key) continue;

      var qty = parseInt(row.getAttribute('data-magon-qty') || '1', 10);
      var flag = 'mgbf_' + key;

      // Quantidade correta: limpa o contador de tentativas e segue.
      if (!(qty > 1)) {
        storageRemove(flag);
        continue;
      }

      // Trava anti-loop: no máximo 3 correções por item por sessão.
      var tries = parseInt(storageGet(flag) || '0', 10);
      if (tries >= 3) continue;
      storageSet(flag, tries + 1);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 1 })
      })
        .then(function (r) {
          if (r.ok) window.location.reload();
        })
        .catch(function () {});

      return; // corrige um por vez; o reload cuida dos demais
    }
  }

  if (document.readyState !== 'loading') {
    fixBrindes();
  } else {
    document.addEventListener('DOMContentLoaded', fixBrindes);
  }
  document.addEventListener('cart:update', fixBrindes);
})();
